/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getTile} from '../api'

 export const useQueryGetTile = createReactQueryHook('getTile', getTile)
